<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mt-4" v-bind="attrs" v-on="on" small>
        {{ $t('cdrs.btn.bulk', { count: items.length }) }}
        <v-icon class="ml-2" color="primary">mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item link @click="$emit('bulk-download', items)" :disabled="!hasRecordings">
        <v-icon class="mr-2" color="primary" small>mdi-download</v-icon>
        <v-list-item-title>{{ $t('cdrs.btn.download') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'cdr-bulk-btn',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasRecordings () {
      return this.items.some(item => item.recording)
    }
  }
}
</script>
